<template>
  <apexchart
    ref="apexChartComponent"
    type="donut"
    :options="chartOptions"
    :series="series"
    :width="206"
    :height="206"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { exportToPng } from '@/utils/pngExporter.js'

export default {
  name: 'DonutChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      required: true,
    },
    plays: {
      type: Array,
      default: () => [0, 0, 0],
    },
    labels: {
      type: Array,
      default: () => ['Desktop', 'Mobile', 'Outros'],
    },
    colors: {
      type: Array,
      default: () => [
        '#3F55EE',
        '#20C1A4',
        '#FF882B',
        '#9D1DA0',
        '#FFC107',
        '#CBCBCB',
      ],
    },
  },
  computed: {
    chartOptions() {
      return this.getDonutChartOptions()
    },
  },
  methods: {
    exportChart(filename = 'grafico-donut.png') {
      if (this.$refs.apexChartComponent) {
        const chartInstance = this.$refs.apexChartComponent.chart
        exportToPng(filename, chartInstance)
      } else {
        console.error('Referência interna do ApexChart não encontrada.')
      }
    },
    getDonutChartOptions() {
      const isDark = this.$vuetify.theme.dark
      const plays = this.plays

      return {
        chart: {
          type: 'donut',
          redrawOnWindowResize: false,
          redrawOnParentResize: false,
        },
        labels: this.labels || ['Desktop', 'Mobile', 'Outros'],
        colors: this.colors,
        tooltip: {
          theme: isDark ? 'dark' : 'light',
          custom: function ({ seriesIndex, w }) {
            const label = w.globals.labels[seriesIndex]
            const playsValue = plays[seriesIndex] ?? 0
            const totalPlays = plays.reduce((acc, val) => acc + (val || 0), 0)
            const percent =
              totalPlays > 0 ? Math.round((playsValue / totalPlays) * 100) : '0'

            return `
              <div style="
                padding: 8px 16px;
                background: ${isDark ? '#363949' : '#EDEEF1'};
                color: ${isDark ? '#E3E4E8' : '#282931'};
                border-radius: 4px 4px 0px 0px;
                font-size: 12px;
                font-family: Rubik, sans-serif;
              ">
                ${label}
              </div>
              <div style="
                padding: 16px 16px;
                background: ${isDark ? '#171924' : '#FFF'};
                color: ${isDark ? '#E3E4E8' : '#282931'};
                border-radius: 0px 0px 4px 4px;
                font-size: 12px;
                font-family: Rubik, sans-serif;
              ">
                Plays: ${playsValue.toLocaleString()} (${percent}%)
              </div>
            `
          },
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        stroke: { show: false },
        states: {
          hover: { filter: { type: 'none' } },
          active: { filter: { type: 'none' } },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { position: 'bottom' },
            },
          },
        ],
      }
    },
  },
}
</script>

<style></style>
